import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

/**
 * use to subscribe to viewport resize changes and output the width of elementRef input param.
 * @param elementRef - element to check width
 * @param bounceTime - bounce timer for checking width. for performance.
 * @returns width of the watching element.
 */
var useWidth = function useWidth(elementRef) {
  var bounceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var _React$useState = React__default.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    width = _React$useState2[0],
    setWidth = _React$useState2[1];
  var resizeBounceTimerRef = useRef(null);
  React__default.useLayoutEffect(function () {
    var resizeObserver = new ResizeObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        element = _ref2[0];
      clearTimeout(resizeBounceTimerRef.current);
      resizeBounceTimerRef.current = setTimeout(function () {
        setWidth(element.contentRect.width);
      }, bounceTime);
    });
    // Only observe when the element is rendered
    if (elementRef.current) resizeObserver.observe(elementRef.current);
    return function () {
      if (elementRef.current) resizeObserver.unobserve(elementRef.current);
    };
  }, [elementRef]);
  return width;
};

export { useWidth };
